import React, { useEffect, useState } from "react";
import CIcon from "@coreui/icons-react";
import { cilMicrophone } from "@coreui/icons";
import { CContainer } from "@coreui/react";
import { LandingPageCss } from "../../../styles/landingPage";
import Wave from "react-wavify";
import { useNavigate, useSearchParams } from "react-router-dom";

import SpeechRecognition, {
  useSpeechRecognition,
} from "react-speech-recognition";
import { CHATGPT_SEARCH_QUERY, GET_ALL_USERS } from "../../../api";
import { useSharedContext } from "../../../context/serviceContext";

const LandingPage = () => {
  const [isRecording, setIsRecording] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isProceed, setIsProceed] = useState(false);
  const [isFinal, setIsfinal] = useState(false);

  const [query, setQuery] = useState("");

  const { shareData, setShareData } = useSharedContext();

  let navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const recordingHandler = () => {
    setIsClicked(true);
    setIsRecording((val) => {
      return !val;
    });
  };

  useEffect(() => {
    console.log("CHECK vlaues", isRecording, isClicked);
    if (isRecording) {
      SpeechRecognition.startListening();
      setIsProceed(false);
    } else if (isClicked && !isRecording) {
      SpeechRecognition.stopListening();
    }
  }, [isClicked, isRecording]);

  const { transcript, resetTranscript } = useSpeechRecognition({
    continuous: true,
  });

  // useEffect(() => {
  //   setQuery(transcript)
  // }, [transcript]);

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return null;
  }

  const proceedHandler = () => {
    setQuery(transcript);
    setIsProceed(true);
  };

  const queryChangeHandler = (e) => {
    setQuery(e.target.value);
  };

  const searchHandler = () => {
    // CHAT GPT API CALL
    console.log("Calling!!");
    CHATGPT_SEARCH_QUERY({
      params: {
        query: query,
      },
    })
      .then((e) => {
        console.log("CHATGPT RESPONSE:", e);

        // Set response
        setShareData({
          ...shareData,
          chatgptResponse: e.data,
        });

        navigate(`/compiler?searchQuery=${query}`);
      })
      .catch((e) => {
        navigate(`/compiler?searchQuery=${query}`);
      });
  };

  return (
    <>
      <LandingPageCss />
      <CContainer>
        <CContainer className="parent-container">
          {/* {isRecording && (
            <div className="recorder-container">
              <div className="outer"></div>
              <div className="outer-2"></div>
              <div className="icon-microphone">
                <CIcon
                  className="mic-icon"
                  icon={cilMicrophone}
                  size="9xl"
                  onClick={recordingHandler}
                />
              </div>
            </div>
          )}
          {!isRecording && (
            <div className="recorder-container">
              <CIcon
                icon={cilMicrophone}
                size="9xl"
                onClick={recordingHandler}
              />
            </div>
          )} */}
          <div className="mic-container">
            <CIcon icon={cilMicrophone} size="9xl" onClick={recordingHandler} />
            Hello, How can I help you Today?
            {isRecording && (
              <Wave
                fill="gray"
                paused={false}
                options={{
                  height: 20,
                  amplitude: 30,
                  speed: 0.4,
                  points: 5,
                }}
                className="wave-div"
              />
            )}
          </div>
          <div className="recorder-content">
            {/* <button onClick={SpeechRecognition.startListening}>Start</button>
            <button onClick={SpeechRecognition.stopListening}>Stop</button> */}
            {/* <button onClick={resetTranscript}>Reset</button> */}
            <p>{transcript}</p>
            {!isRecording && isClicked && !isProceed && (
              <button onClick={proceedHandler}>Proceed</button>
            )}
            {isProceed && (
              <input
                type="text"
                value={query}
                onChange={queryChangeHandler}
              ></input>
            )}
            {isProceed && (
              <button type="button" onClick={searchHandler}>
                Search
              </button>
            )}
          </div>
        </CContainer>
        <CContainer></CContainer>
      </CContainer>
    </>
  );
};

export default LandingPage;
